<template>
  <v-card
  flat
  :class="`pa-0 ga-0 d-flex justify-center align-center flex-column flex-sm-${isFlipped ? 'row' : 'row-reverse'}`"
  color="secondary"
  rounded="lg"
  min-height="340px"
  >
  <a :href="popupContent.btn_1_href" target="_blank" :class="['w-100', hasTitleAndContent ? 'w-md-50' : 'w-md-100']">
    <div
    class="w-100 h-100"
    :style="imageStyles"
    ></div></a>
    <div v-if="hasTitleAndContent" class="w-100 w-md-50 pa-6 d-flex flex-column justify-center align-start">
      <h1 class="text-left info_title pb-0 lang_translate">{{ popupData?.name }}</h1>
      <p class="text-left font-weight-thin lang_translate" v-html="popupContent.content"></p>
      <br />
      <Button
      :slim="true"
      version="action"
      :label="popupContent.btn_1_content"
      @click="navigateTo(popupContent.btn_1_href)"
      class="lang_translate"
      />
    </div>
  </v-card>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';

import Button from '@/components/ComponentLibrary/Button.vue';

const props = defineProps<{
  popupData: any;
  popupContent: any;
}>();

const isFlipped = ref(Math.random() < 0.5);

const windowWidth = ref(window.innerWidth);
window.addEventListener('resize', () => {
  windowWidth.value = window.innerWidth;
});

const imageStyles = computed(() => ({
  backgroundImage: `url(${props.popupContent.img_url})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  minHeight: windowWidth.value < 600 ? '350px' : '400px',
}));

const hasTitleAndContent = computed(() =>
  Boolean(props.popupData?.name?.trim()) &&
  Boolean(props.popupContent?.content?.trim())
);

const navigateTo = (href: string) => {
  if (href.startsWith('/')) {
    window.location.href = href;
  } else {
    window.open(href, '_blank');
  }
};

defineExpose({
  onClose() {
    const id = props.popupData?.id;
    if (!id) return;

    const dismissedRaw = localStorage.getItem('dismissedPopups') || '{}';
    const dismissedMap: Record<number, string> = JSON.parse(dismissedRaw);
    dismissedMap[id] = new Date().toISOString();
    localStorage.setItem('dismissedPopups', JSON.stringify(dismissedMap));
  }
});

</script>

<style lang="scss">

</style>